<template>
  <div>
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="cashBackModal"
        persistent
        max-width="800px"
      >
        <v-card>
          <form
            action=""
            @submit.prevent="submitForm()"
          >
            <v-card-title>
              <v-flex
                xs11
                sm11
                md11
              ><span class="headline">Credit Cash Back</span></v-flex>
              <v-flex
                xs1
                sm1
                md1
              >
                <v-btn
                  flat
                  @click="closeCashBackModal(), $validator.reset()"
                  class="close"
                ><span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-alert
                type="success"
                :value="checkAlert"
              >
                Credit cashed back successfully
              </v-alert>
              <v-alert
                type="error"
                :value="cashBackError"
              >
                Cash back amount is more than customer credit
              </v-alert>
              <v-layout wrap>
                <!-- <v-flex
                  xs12
                  class="px-2"
                >
                  <branch-select v-model="cashBackData.branch_id_fk" />
                </v-flex> -->

                <v-flex
                  xs12
                  sm10
                  md6
                  class="px-2"
                >
                  <v-select
                    autocomplete
                    :items="customers"
                    v-model="cashBackData.user_id_fk"
                    :error-messages="errors.collect('Customer')"
                    data-vv-name="Customer"
                    label="Customer*"
                    v-validate="'required'"
                    single-line
                  >
                  </v-select>
                </v-flex>
                <v-flex
                  xs12
                  sm10
                  md6
                  class="px-2"
                >
                  <v-text-field
                    label="Amount*"
                    v-model.number="cashBackData.amount"
                    :error-messages="errors.collect('amount')"
                    v-validate="'required|decimal:2'"
                    data-vv-name="amount"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex
                  xs12
                  class="px-2"
                >
                  <v-text-field
                    label="Note"
                    v-model="cashBackData.note"
                  >
                  </v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="height:auto"
                @click="closeCashBackModal(), $validator.reset()"
                outline
                color="normal"
              >Cancel</v-btn>
              <v-btn
                type="submit"
                :loading="load2"
                style="height:auto; margin-right: 3%"
                outline
                color="success"
              >Save</v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: [
    'cashBackModal',
    'closeCashBackModal',
    'checkAlert',
    'cashBackError',
    'cashBackData',
    'cashBack',
    'backendError',
    'load2',
    'customers'
  ],

  methods: {
    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.cashBack()
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/user/user_credit/cashBack.vue